<div class="flex w-full">
	<app-matter-mortgage-payments
		class="w-full"
		[mortgage]="_mortgage"
	></app-matter-mortgage-payments>
</div>
